import React, {useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ActionButtonsContainer} from "./ActionButtons.styles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {Button, Tooltip} from "antd";
import {CreateEquipmentModal} from "../modals/createEquipmentModal/CreateEquipmentModal";

const ActionButtons = ({recall = () => {}}) => {
    const {t} = useTranslation([]);
    const history = useHistory();
    const [showCreateEquipmentModal, setshowCreateEquipmentModal] = useState(false);

    const openCreateEquipmentModal = () => {
        setshowCreateEquipmentModal(true);
    };
    const closeCreateEquipmentModal = () => {
        setshowCreateEquipmentModal(false);
    };

    return (
        <>
            <ActionButtonsContainer>
                <Tooltip title={"Ekipman Tiplerini Görüntüle"}>
                    <Button
                        type="ghost"
                        data-testid="link"
                        onClick={() => history.push("/equipments/types")}
                    >
                        {"Ekipman Tipleri"}
                    </Button>
                </Tooltip>
                <Tooltip title={"Yeni Ekipman Oluştur"}>
                    <CustomButton
                        type="primary"
                        data-testid="createNew"
                        onClick={openCreateEquipmentModal}
                        icon={<PlusOutlined />}
                    >
                        {"Yeni Ekipman Oluştur"}
                    </CustomButton>
                </Tooltip>
            </ActionButtonsContainer>

            {/* Modals */}
            <CreateEquipmentModal
                visibility={showCreateEquipmentModal}
                recall={recall}
                changeVisibility={setshowCreateEquipmentModal}
                onCancel={closeCreateEquipmentModal}
                onOk={closeCreateEquipmentModal}
            />
        </>
    );
};

export default ActionButtons;
